import React from 'react';
// To make sure Showtime doesn't create more than one React context,
// a single Showtime context is created and tracked in global state.
// We use React.createContext as the key instead of just React to avoid
// ambiguities between default and namespace React imports.
const cache = new Map();
export function getShowtimeContext() {
    let context = cache.get(React.createContext);
    if (!context) {
        context = React.createContext({});
        context.displayName = 'ShowtimeContext';
        cache.set(React.createContext, context);
    }
    return context;
}
//# sourceMappingURL=ShowtimeContext.js.map